import { SubscriptionType } from 'src/shared/types';

const TIER_LABELS: Partial<Record<SubscriptionType, string>> = {
    [SubscriptionType.BASIC]: 'Starter',
    [SubscriptionType.INSIGHTS]: 'Species Insights',
    [SubscriptionType.HABITAT_INSIGHTS]: 'Habitat Insights',
};

/**
 * The tier name an operator would recognise. The graph stores more tiers than the customer stats
 * schema advertises, so anything unmapped falls back to its raw value — a tier we cannot name is
 * still a tier whose project count matters.
 */
export const subscriptionTierLabel = (subscription: SubscriptionType): string => TIER_LABELS[subscription] ?? subscription;
